import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const MessagesIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M13.103 7H7.897c-.212 0-.415.008-.61.032C5.098 7.22 4 8.508 4 10.884v3.243c0 3.244 1.302 3.884 3.897 3.884h.325c.18 0 .415.122.52.26l.977 1.297c.431.576 1.13.576 1.562 0l.976-1.297a.656.656 0 0 1 .52-.26h.326c2.384 0 3.677-1.086 3.865-3.275.024-.195.032-.398.032-.609v-3.243C17 8.297 15.698 7 13.103 7Zm-5.442 6.487a.81.81 0 0 1-.814-.811.815.815 0 0 1 1.627 0c0 .446-.366.81-.813.81Zm2.839 0a.81.81 0 0 1-.814-.811.815.815 0 0 1 1.627 0 .81.81 0 0 1-.813.81Zm2.847 0a.81.81 0 0 1-.813-.811.815.815 0 0 1 1.627 0c0 .446-.366.81-.814.81Z"
      fill={color}
    />
    <Path
      d="M20 7.696v3.086c0 1.543-.485 2.592-1.454 3.17-.235.14-.508-.046-.508-.316l.008-2.854c0-3.086-1.79-4.853-4.917-4.853l-4.76.008c-.274 0-.462-.27-.321-.502C8.634 4.478 9.698 4 11.253 4h5.003C18.749 4 20 5.234 20 7.696Z"
      fill={color}
    />
  </Svg>
);

export default MessagesIcon;
